var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewWorkspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 80,
    viewBox: "0 0 108 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 40,
    r: 40,
    fill: "#DADFF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#465DD8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#465DD8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 24,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#465DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63 38.0176L56.3838 44.6338C56.1396 44.8779 55.8198 45 55.5 45C55.1802 45 54.8604 44.8779 54.6162 44.6338L50.5 40.5176L45.1338 45.8838C44.8896 46.1279 44.5698 46.25 44.25 46.25C43.536 46.25 43 45.6661 43 45C43 44.6802 43.1221 44.3604 43.3662 44.1162L49.6162 37.8662C49.8604 37.6221 50.1802 37.5 50.5 37.5C50.8198 37.5 51.1396 37.6221 51.3838 37.8662L55.5 41.9824L61.2324 36.25H63V38.0176Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.25 42.5C63.5591 42.5 63 41.9403 63 41.25V36.25H58C57.3091 36.25 56.75 35.6903 56.75 35C56.75 34.3097 57.3091 33.75 58 33.75H64.25C64.9409 33.75 65.5 34.3097 65.5 35V41.25C65.5 41.9403 64.9409 42.5 64.25 42.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23 45C23 45.2881 22.7783 46 22 46C21.8066 46 21.5264 45.9014 21.375 45.7803L18.7178 43.6543C17.6464 42.7978 16.352 42.2679 15 42.0854V34.9146C16.352 34.7321 17.6465 34.2022 18.7188 33.3457L21.376 31.2197C21.5566 31.0742 21.7773 31 22 31C22.7822 31 23 31.7266 23 32V45Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 36.7773V40.2226C23.5957 39.876 24 39.2383 24 38.5C24 37.7617 23.5957 37.124 23 36.7773ZM10 35C8.8955 35 8 35.8955 8 37V40C8 41.1045 8.8955 42 10 42H10.079C9.74269 44.4312 11.1584 46.477 11.2295 46.5773C11.4199 46.845 11.7022 47 12 47H14C14.4043 47 14.7695 46.7163 14.9238 46.2799C15.0791 45.8436 14.9932 45.3423 14.707 45.0084C14.6934 44.9925 13.4454 43.4554 13.8118 42H14C14.3362 42 14.6687 42.0407 15 42.0854V34.9146C14.6686 34.9593 14.3362 35 14 35H10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95 36.5C95 39.5375 92.0898 42 88.5 42C87.3068 42 86.1924 41.7233 85.2313 41.2486C84.4506 41.6525 83.4377 42 82.2394 42C82.1438 42 82.0594 41.9461 82.02 41.8561C81.9816 41.7661 81.9994 41.6639 82.0651 41.595C82.0763 41.5837 82.7902 40.8163 83.3023 39.7925C82.4882 38.8738 82 37.7366 82 36.5C82 33.4624 84.9102 31 88.5 31C92.0898 31 95 33.4624 95 36.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.939 46.595C102.004 46.6639 102.022 46.7661 101.984 46.8561C101.944 46.9461 101.86 47 101.764 47C100.631 47 99.6677 46.6881 98.9053 46.3131C98.0451 46.7498 97.0567 47 96.0038 47C93.1908 47 90.8368 45.2232 90.1875 42.8288C93.5138 42.164 96.0038 39.5818 96.0038 36.5C96.0038 36.3317 95.9892 36.1665 95.9746 36.0013C95.9844 36.0013 95.994 36 96.0038 36C99.3175 36 102.004 38.4624 102.004 41.5C102.004 42.7698 101.53 43.9358 100.741 44.8667C101.25 45.8521 101.928 46.584 101.939 46.595Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWorkspace);
export default __webpack_public_path__ + "static/media/NewWorkspace.7e669813.svg";
export { ForwardRef as ReactComponent };